import { formatDate } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';

@Component({
  selector: 'app-festival-promotions',
  templateUrl: './festival-promotions.component.html',
  styleUrls: ['./festival-promotions.component.scss']
})
export class FestivalPromotionsComponent extends FeaturesBaseComponent implements OnInit {
  @Input() ocassionRewards: [];
  @Input() startDate;
  @Input() endDate;
  occasionRewardsColumnDef: any = [];
  rowSelection: string;
  futureDays = [{ days: 10, value: 'Next 10 days' }, { days: 20, value: 'Next 20 days' }, { days: 30, value: 'Next 30 days' }, { days: 60, value: 'Next 60 days' }, { days: 90, value: 'Next 90 days' }];
  selectedDays = this.futureDays[0].days;
  searchValue;
  searchhistoryValue;
  rowData: any;
  occasionsRowData: any;
  dateSelected: any;
  currentDate: Date;
  futureDate: any;
  showUpdateUser: boolean = true;
  selectedRows: any;
  minFromDate;
  maxDate;
  minToDate;
  toCtrl = new FormControl("");
  fromCtrl = new FormControl("");
  isRowSelected: boolean = false;
  isButtonDisabled:boolean
  
  
  
  private gridApi;
  private gridColumnApi;
  

  constructor(private promotionService: PromotionsService, private router: Router,private adminViewServices:AdminViewService) {
    super();
  }

  ngOnInit(): void {

     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
    const self = this;

    super.ngOnInit();
    this.occasionRewardsColumnDef = [
      { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true }, 
      { field: 'occassionId', headerName: '', hide: true },
      { field: "occassionName", headerName: "Festival", width: 220 },
      { field: "country", headerName: "Country", width: 180 },
      {
        field: "occationStartdttm", headerName: "Start Date", width: 180, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY')
        }
      },
      {
        field: "occassionEnddttm", headerName: "End Date", width: 180, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY')
        }
      },
      {
        field: "promocodeStartDateTime", headerName: "Promo Start Date", width: 220, cellRenderer: (params) => {
          if(params.data.promocodeStatus == 'Active'){
            return moment(params.value).format('MM/DD/YYYY')
          }
          return `-`;
        }
      },
      {
        field: "promocodeEndDateTime", headerName: "Promo End Date", width: 220, cellRenderer:(params) => {
          if(params.data.promocodeStatus == 'Active'){
            return moment(params.value).format('MM/DD/YYYY')
          }
          return `-`;
        }
      },
      {
        field: "promocodeStatus", headerName: "Status", width: 120, cellRenderer: function (params) {
          if (params.value == 'Active') {
            return '<span >Active</span>'
          }
          return '<span> - </span>';
        }
      },
      {
        field: "promocodeStatus", headerName: "Manage", width: 150, cellRenderer: function (params) {
          if (params.value == 'Active') {
            return '<span style="display:block;margin-left: 1.25rem;cursor:pointer;" class="mi mi-visibility text-primary"></span>'
          }
          return `<span style="display:block;margin-left: 1.25rem;cursor: pointer;" *hideIfUnauthorized="'Create Promo Code'" class="mi mi-add-circle text-main mt-2"></span>`;

        }, onCellClicked: function (params) {
          self.editPromoCode(params.data);

        },
      },

    ];
  }

  editPromoCode(obj) {
   
    let promo:any=obj;
    this.router.navigate([`features/promotions/manage-promo/edit-promotion`], { state: promo })
  }


  ngOnDestroy() {
    super.ngOnDestroy();
  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes['ocassitonRewards']) {
      this.ocassionRewards = changes['ocassitonRewards'].currentValue;
    }
    if (changes['startDate']) {
      this.startDate = changes['startDate'].currentValue;
      this.fromCtrl.setValue(this.startDate);
      this.minToDate = new Date();
    }
      if (changes['endDate']) {
      this.endDate = changes['endDate'].currentValue;
      this.toCtrl.setValue(this.endDate)

    }
  }


  seeFestivalsUpto(data) {
    this.dateSelected = data.value;
    this.currentDate = new Date();
    this.futureDate = this.currentDate.setDate(this.currentDate.getDate() + this.dateSelected);
    let startDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let endDate = formatDate(this.futureDate, 'yyyy-MM-dd', 'en');
    
    this.promotionService.getOccasionFestivalsHistory(endDate, startDate)
      .subscribe(res => {
        this.ocassionRewards = res['data'];
      });
  }


  onRefreshCarrierPromotions() {
    this.promotionService.getOccasionsFestivalRefreshed()
        // FIXME: waiting for occasions API fix
      .subscribe(res => {
        if(res['httpcode'] == 200 && res['data'] == []){
          this.ocassionRewards = res['data'];
        }
        else{
          this.toastrService.warning('Unable to load occasions','')
        }
      })
  }
  onSelectionChanged(e) {
    //
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0) {
      this.showUpdateUser = false;
      return
    }
    this.showUpdateUser = true;
  }  
  updateFestival() {
   
    //return;
    let occassionId = this.selectedRows[0].occassionId;
    this.router.navigate([`features/promotions/ocassion-rewards/update-festival/${occassionId}`])
  }
  exportData(){}
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      //this.getDateChangeResult(this.startDate, this.endDate);
      this.promotionService.getOccasionFestivalsHistory(this.endDate, this.startDate)
      .subscribe(res => {
        this.ocassionRewards = res['data'];
      });
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.promotionService.getOccasionFestivalsHistory(this.endDate, this.startDate)
      .subscribe(res => {
        this.ocassionRewards = res['data'];
      });
    }
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }
}
